export type HolidayBannerBackground = 'black-gold' | 'purple';

export type HolidayBannerTextPart = {
  text: string;
  bold?: boolean;
};

export type HolidayBannerConfig = {
  startDate: string;
  endDate: string;
  textParts: HolidayBannerTextPart[];
  background: HolidayBannerBackground;
  campaignUrl?: string;
};

/**
 * Default banner configuration (purple background)
 * Shown when no scheduled banner is active
 */
export const DEFAULT_HOLIDAY_BANNER: HolidayBannerConfig = {
  startDate: '',
  endDate: '',
  textParts: [{ text: 'Free Shipping', bold: true }, { text: ' for orders above {{threshold}}' }],
  background: 'purple',
};

/**
 * Holiday Banner rotation schedule
 * All times are in SGT (Asia/Singapore timezone)
 * Format: 'YYYY-MM-DD HH:mm:ss'
 */
export const HOLIDAY_BANNER_ROTATIONS: HolidayBannerConfig[] = [
  // GGU Phase 1: The Glow Lab - Jun 10 (3PM) - Jun 24 (4PM)
  {
    startDate: '2026-06-10 15:00:00',
    endDate: '2026-06-24 16:00:00',
    textParts: [
      { text: 'The Glow Lab: ', bold: true },
      { text: 'Up to 50% OFF Sitewide!' },
    ],
    background: 'purple',
    campaignUrl: '/campaign/great-glow-up/',
  },
  // GGU Phase 2: The Great Glow Up - Jun 24 (4PM) - Jul 1 (4PM)
  {
    startDate: '2026-06-24 16:00:00',
    endDate: '2026-07-01 16:00:00',
    textParts: [
      { text: 'The Great Glow Up: ', bold: true },
      { text: 'Up to 70% OFF of Sitewide' },
    ],
    background: 'purple',
    campaignUrl: '/campaign/great-glow-up/',
  },
];

export const HOLIDAY_BANNER_TIMEZONE = 'Asia/Singapore';
